// @flow

// eslint-disable-next-line import/prefer-default-export
export const MERGE_STATE: 'components/AppBar/MERGE_STATE' =
  'components/AppBar/MERGE_STATE';
